import api from "@/services/api";

export const state = {
  association: {},
  associations: [],
  associationActivities: [],
  associationDetails: {},
  associationHistory: [],
  associationHistoryById: {},
  associationLiquidations: [],
  associationRequests: [],
};

export const mutations = {
  INIT_ASSOCIATION(state, payload) {
    state.association = payload;
  },
  INIT_ASSOCIATIONS(state, payload) {
    state.associations = payload;
  },
  INIT_ASSOCIATION_ACTIVITIES(state, payload) {
    state.associationActivities = payload;
  },
  INIT_ASSOCIATION_DETAILS(state, payload) {
    state.associationDetails = payload;
  },
  INIT_ASSOCIATION_HISTORY(state, payload) {
    state.associationHistory = payload;
  },
  INIT_ASSOCIATION_HISTORY_BY_ID(state, payload) {
    state.associationHistoryById = payload;
  },
  INIT_ASSOCIATION_LIQUIDATIONS(state, payload) {
    state.associationLiquidations = payload;
  },
  INIT_ASSOCIATION_REQUESTS(state, payload) {
    state.associationRequests = payload;
  },
};

export const actions = {
  getAssociations({ commit }, payload) {
    return api.getAssociations(payload).then((response) => {
      commit("INIT_ASSOCIATIONS", response.data.data);

      if (!payload.retrieveAll) commit("pager/INIT_PAGER", response.data.pagedResult, { root: true });
    });
  },
  getAssociation({ commit }, payload) {
    api.getAssociationById(payload).then((response) => {
      commit("INIT_ASSOCIATION", response.data.data);
    });
  },
  getActivities({ commit }, payload) {
    api.getAssociationActivities(payload.associationId,payload).then((response) => {
      commit("INIT_ASSOCIATION_ACTIVITIES", response.data.data);

      if (!payload.retrieveAll) commit("pager/INIT_PAGER_ACTIVITY", response.data.pagedResult, { root: true });
    });
  },
  getDetails({ commit }, payload) {
    api.getAssociationDetailsById(payload).then((response) => {
      commit("INIT_ASSOCIATION_DETAILS", response.data.data);
    });
  },
  getRequests({ commit }, payload) {
    api.getAssociationRequests(payload.associationId,payload).then((response) => {
      commit("INIT_ASSOCIATION_REQUESTS", response.data.data);

      if (!payload.retrieveAll) commit("pager/INIT_PAGER_REQUEST", response.data.pagedResult, { root: true });
    });
  },
  getHistory({ commit }, payload) {
    api.getAssociationHistory(payload).then((response) => {
      commit("INIT_ASSOCIATION_HISTORY", response.data.data);

      if (!payload.retrieveAll) commit("pager/INIT_PAGER", response.data.pagedResult, { root: true });
    });
  },
  getHistoryById({ commit }, payload) {
    api.getAssociationHistoryById(payload).then((response) => {
      commit("INIT_ASSOCIATION_HISTORY_BY_ID", response.data.data);
    });
  },
  getLiquidations({ commit }, payload) {
    api.getAssociationLiquidations(payload).then((response) => {
      commit("INIT_ASSOCIATION_LIQUIDATIONS", response.data.data);
    });
  },
}

export const getters = {
  getAssociation: (state) => state.association,
  getAssociations: (state) => state.associations,
  getActivities: (state) => state.associationActivities,
  getDetails: (state) => state.associationDetails,
  getHistory: (state) => state.associationHistory,
  getHistoryById: (state) => state.associationHistoryById,
  getLiquidations: (state) => state.associationLiquidations,
  getRequests: (state) => state.associationRequests,
};
